An email address.
